export const USER_RECENT_BOARDS_MAX_SIZE: number = 100;
export const USER_RECENT_BOARDS_NAV_PANEL_MAX: number = 10;
